{
  "sdk-download-android": "Prenos za Android",
  "sdk-connect": "Poveži",
  "sdk-download-ios": "Prenos za iOS",
  "sdk-install": "Namesti",
  "sdk-modal-instruct-1": "1. Odprite aplikacijo Binance",
  "sdk-modal-instruct-2": "2. Tapnite {{icon}} na začetnem zaslonu",
  "sdk-modal-title": "Povežite se s platformo Binance",
  "sdk-no-app": "Še nimate aplikacije Binance?"
}